import { Tabs } from 'antd-v5';
import styled from 'styled-components';
import { theme } from 'styles';

export const borderSetting = `solid 1px ${theme.color.grey85}`;

export const BorderedBox = styled.div`
  border: ${borderSetting};
  border-radius: 2px;
  flex: 1;
`;

export const SListItem = styled.div`
  margin-bottom: 15px;
  box-shadow: 0 5px 12px 4px ${theme.color.shadow_6}, 0 3px 6px 0 ${theme.color.shadow_5},
    0 1px 2px -2px ${theme.color.shadow_4};
  white-space: nowrap;
`;

export const SImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const STabs = styled(Tabs)`
  flex: 1;

  .ant5-tabs-nav {
    margin: 0;

    .ant5-tabs-tab {
      border: solid 1px ${theme.color.brand_black};
      border-radius: 8px;
      flex: 1;
      justify-content: center;
    }
  }

  .ant5-tabs-nav-wrap .ant5-tabs-tab-active {
    background: white;

    .ant5-tabs-tab-btn {
      color: ${theme.color.brand_black};
      font-weight: 600;
    }
  }

  .ant5-tabs-nav-more {
    display: none;
  }
`;
